import React from 'react';
import SecuredZone from '../SecuredZone/SecuredZone';
import Dialog from '@material-ui/core/Dialog';
import API from '../../../api/api';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getImageUrl } from '../../../utils/imageUtils';
import { Component } from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
  IconButton,
  Tooltip
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import AdminServicesDialog from '../../../dialogs/admin-services/admin-services';

const garageApi = new API();

class AdminServices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      adminServicesDialog: false,
      services: [],
      editService: {},
    };
  }

  componentDidMount() {
    this.loadServices();
  }

  loadServices() {
    this.setState({ loading: true });
    garageApi.endpoints.services.getAll()
      .then((getRequest) => {
        try {
          console.log('Admin Services API response:', getRequest);
          console.log('Admin Services data:', getRequest.data);
          
          // Unterstütze sowohl results als auch direkte Arrays
          let services = [];
          if (getRequest && getRequest.data) {
            if (Array.isArray(getRequest.data)) {
              services = getRequest.data;
            } else if (getRequest.data.results && Array.isArray(getRequest.data.results)) {
              services = getRequest.data.results;
            }
          }
          
          console.log('Parsed admin services:', services);
          
          // Setze Services zuerst, damit sie angezeigt werden
          this.setState({ services: services, loading: false });
          
          // Lade Bild-Objekte für Services, die nur eine Bild-ID haben (optional, im Hintergrund)
          const servicesWithImages = services.map(service => {
            // Wenn image nur eine ID ist (Zahl), lade das Bild-Objekt
            if (service.image && typeof service.image === 'number') {
              return garageApi.endpoints.image.getOne({ id: service.image })
                .then(imageResponse => {
                  // Aktualisiere nur den Service mit dem geladenen Bild
                  this.setState(prevState => ({
                    services: prevState.services.map(s => 
                      s.id === service.id 
                        ? { ...s, image: imageResponse.data }
                        : s
                    )
                  }));
                  return {
                    ...service,
                    image: imageResponse.data
                  };
                })
                .catch(error => {
                  console.error('Error loading image for service:', error);
                  return service; // Fallback: Service ohne Bild
                });
            }
            return Promise.resolve(service);
          });
          
          // Lade Bilder im Hintergrund (nicht blockierend)
          Promise.all(servicesWithImages)
            .then(servicesWithLoadedImages => {
              console.log('Services with loaded images:', servicesWithLoadedImages);
            })
            .catch(error => {
              console.error('Error loading images for services:', error);
            });
        } catch(e) {
          console.error('Error parsing admin services:', e);
          console.error('Error details:', e);
          this.setState({ services: [], loading: false });
        }
      })
      .catch((error) => {
        console.error('Error loading admin services:', error);
        console.error('Error response:', error.response);
        console.error('Error message:', error.message);
        this.setState({ services: [], loading: false });
      });
  }

  deleteService(unikey) {
    if (!window.confirm('Möchten Sie diese Dienstleistung wirklich löschen?')) {
      return;
    }

    var deleteService = this.state.services.find((element) => { return element.unikey === unikey; });
    if (!deleteService) return;

    this.setState({ loading: true });

    garageApi.endpoints.services.delete({ id: deleteService.id })
      .then(() => {
        this.loadServices();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  closeAdminServicesDialog() {
    this.setState({ adminServicesDialog: false });
    this.setState({ editService: {} });
  }

  submitAdminServicesDialog(mode, service) {
    this.setState({ loading: true });
    if(mode) {
      garageApi.endpoints.services.create(service)
        .then(() => {
          this.loadServices();
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } else {
      garageApi.endpoints.services.update(service)
        .then(() => {
          this.loadServices();
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
    this.setState({ adminServicesDialog: false });
    this.setState({ editService: {} });
  }

  editService(unikey) {
    var editService = this.state.services.find((element) => { return element.unikey === unikey; });
    this.setState({ editService: editService || {} });
    this.setState({ adminServicesDialog: true });
  }

  createService() {
    this.setState({ adminServicesDialog: true });
  }

  render() {
    const { loading, services, adminServicesDialog, editService } = this.state;

    return (
      <SecuredZone
        breadcrumbs={{ '/admin/': 'Dashboard', '/admin/services': 'Dienstleistungen' }}
        menu={{ 'Dienstleistung Hinzufügen': this.createService.bind(this) }}
        title="Dienstleistungen"
        loading={loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        <Dialog 
          open={adminServicesDialog} 
          onClose={this.closeAdminServicesDialog.bind(this)}
          maxWidth="md"
          fullWidth
        >
          <AdminServicesDialog 
            servicesData={editService} 
            close={this.closeAdminServicesDialog.bind(this)} 
            submit={this.submitAdminServicesDialog.bind(this)}
          />
        </Dialog>
        
        {!loading && (
          <Box style={{ padding: '20px' }}>
            {/* Statistik */}
            <Paper elevation={2} style={{ padding: '20px', marginBottom: '24px', background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', color: 'white' }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="h4" style={{ fontWeight: 700, marginBottom: '8px' }}>
                    {services.length}
                  </Typography>
                  <Typography variant="body1" style={{ opacity: 0.9 }}>
                    {services.length === 1 ? 'Dienstleistung' : 'Dienstleistungen'} insgesamt
                  </Typography>
                </Box>
                <AttachFileIcon style={{ fontSize: 60, opacity: 0.3 }} />
              </Box>
            </Paper>

            {/* Services Grid */}
            {services.length > 0 ? (
              <Grid container spacing={3}>
                {services.map((service) => {
                  // Prüfe ob image ein Objekt ist oder nur eine ID
                  const imageUrl = service.image && typeof service.image === 'object' 
                    ? getImageUrl(service.image, 'large') 
                    : null;
                  const hasImage = !!imageUrl;
                  
                  return (
                    <Grid item xs={12} sm={6} md={4} key={service.unikey || service.id}>
                      <Card 
                        style={{ 
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          transition: 'transform 0.2s, box-shadow 0.2s',
                          position: 'relative',
                          backgroundImage: hasImage ? `url(${imageUrl})` : 'none',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundColor: hasImage ? 'transparent' : '#f5f5f5',
                          minHeight: '300px',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-4px)';
                          e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                        }}
                      >
                        {/* Overlay für bessere Lesbarkeit */}
                        {hasImage && (
                          <Box
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)',
                              zIndex: 1,
                            }}
                          />
                        )}
                        <CardContent style={{ 
                          flexGrow: 1, 
                          display: 'flex', 
                          flexDirection: 'column',
                          position: 'relative',
                          zIndex: 2,
                          color: hasImage ? 'white' : 'inherit',
                        }}>
                          <Typography variant="h6" component="h2" style={{ fontWeight: 600, marginBottom: '8px' }}>
                            {service.title || 'Ohne Titel'}
                          </Typography>
                          <Typography 
                            variant="body2" 
                            style={{ 
                              marginBottom: '12px',
                              flexGrow: 1,
                              display: '-webkit-box',
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              color: hasImage ? 'rgba(255,255,255,0.9)' : undefined,
                            }}
                            color={hasImage ? undefined : 'textSecondary'}
                          >
                            {service.description || 'Keine Beschreibung'}
                          </Typography>
                          <Box display="flex" alignItems="center" justifyContent="flex-end" marginTop="auto">
                            <Tooltip title="Bearbeiten">
                              <IconButton 
                                size="small" 
                                onClick={() => { this.editService(service.unikey); }}
                                style={{ color: hasImage ? '#fff' : '#1976d2' }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Löschen">
                              <IconButton 
                                size="small" 
                                onClick={() => { this.deleteService(service.unikey); }}
                                style={{ color: hasImage ? '#fff' : '#d32f2f' }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Paper elevation={2} style={{ padding: '60px', textAlign: 'center' }}>
                <AttachFileIcon style={{ fontSize: 80, color: '#ccc', marginBottom: '20px' }} />
                <Typography variant="h6" color="textSecondary" style={{ marginBottom: '8px' }}>
                  Noch keine Dienstleistungen vorhanden
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Klicken Sie auf "Dienstleistung Hinzufügen" um Ihre erste Dienstleistung zu erstellen.
                </Typography>
              </Paper>
            )}
          </Box>
        )}
      </SecuredZone>
    );
  }
}

export default AdminServices;
